export const rutinRouteName = 'Rutin';
export const styrvardeRouteName = 'Styrvarde';
export const rapportRouteName = 'Rapport';
export const collectionName = 'collectionName';
export const debugRouteName = 'debugRutin';
export const loginRouteName = 'Login';
export const newPasswordRouteName = 'newPassword';
